import React from 'react';
import { useSelector } from 'react-redux';
import { getVoucherForEngine } from './voucherRegistry';
import PaymentFormatLayout from './PaymentFormatLayout';

/**
 * PaymentFormat.
 * Resolves the store-payment voucher for the current payment engine and renders it inside the
 * standalone printable layout. Assumes the container already guarded on a present `reference` and a
 * registered engine.
 *
 * @returns {JSX.Element|null} The voucher wrapped in the print layout, or null if unresolved.
 */
const PaymentFormat = () => {
  const paymentEngine = useSelector((state) => state.payment.get('paymentEngine'));
  const Voucher = getVoucherForEngine(paymentEngine);

  if (!Voucher) return null;

  return (
    <PaymentFormatLayout>
      <Voucher />
    </PaymentFormatLayout>
  );
};

export default PaymentFormat;
